import { render, staticRenderFns } from "./ImageZoom.vue?vue&type=template&id=4675b24b&scoped=true&"
import script from "./ImageZoom.vue?vue&type=script&lang=js&"
export * from "./ImageZoom.vue?vue&type=script&lang=js&"
import style0 from "./ImageZoom.vue?vue&type=style&index=0&id=4675b24b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675b24b",
  null
  
)

export default component.exports